import React, { Suspense, useEffect } from 'react';
import { Routes, Route, useLocation, matchPath } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';

import Header from './components/layouts/Header';
import ContactWhatsapp from './components/layouts/ContactWhatsapp';
import HelpWidget from './components/layouts/HelpWidget';
import Footerbar from './components/layouts/Footerbar';
import FooterbarForPages from './components/layouts/FooterbarForPages';
import LoadingScreen from './components/ui/LoadingScreen';
import ErrorPage from './screens/error/ErrorPage';
import SecondaryHeader from './components/layouts/HeaderForPages';
import { routes } from './routes/routes';
import { ROUTES } from './routes/routePaths';
import { AuthProvider, useAuth } from './context/AuthContext';
import MagicLinkHandler from './components/auth/MagicLinkHandler';

function AppContent() {
    const location = useLocation();
    const { isAuthenticated } = useAuth();
    const landingPage = location.pathname === '/';

    const secondaryHeaderPaths = [
        ROUTES.DASHBOARD,
        ROUTES.FAVOURITE_TENDERS,
        ROUTES.PROFILE,
        ROUTES.CHANGE_PASSWORD,
        ROUTES.LOGOUT,
        ROUTES.UPDATE_QUERY,
        ROUTES.TENDERS_LIVE,
        ROUTES.TENDERS_PRIVATE,
        ROUTES.CONTRACTS_PRIVATE,
        ROUTES.EXPORT_TO_EXCEL,
        ROUTES.ANALYTIC_DASHBOARD,
        ROUTES.EMAIL_TENDERS,
        ROUTES.ADVANCED_SEARCH_LIVE
    ];

    const showSecondaryHeader = secondaryHeaderPaths.some(path => path && location.pathname.toLowerCase().startsWith(path.toLowerCase())) ||
        (isAuthenticated && (
            location.pathname.toLowerCase().startsWith(ROUTES.ADVANCED_SEARCH.toLowerCase()) ||
            location.pathname.toLowerCase().startsWith('/tenders')
        ));

    const hideHeaderFooter = matchPath(ROUTES.TENDER_DOCUMENT, location.pathname);

    return (
        <MagicLinkHandler>
            <div className="min-h-screen flex flex-col">
                {!hideHeaderFooter && (landingPage ? <Header /> : (showSecondaryHeader ? <SecondaryHeader /> :
                    <Header />))}
                <main className="flex-1">
                    <Suspense fallback={<LoadingScreen />}>
                        <Routes>
                            {routes.map((route, index) => (
                                <Route key={index} path={route.path} element={route.element} />
                            ))}
                            <Route path="*" element={<ErrorPage />} />
                        </Routes>
                    </Suspense>
                </main>
                {!hideHeaderFooter && (showSecondaryHeader ? <FooterbarForPages /> : <Footerbar />)}
                <ContactWhatsapp />
                <HelpWidget />
            </div>
        </MagicLinkHandler>
    );
}

function App() {
    return (
        <AuthProvider>
            <SnackbarProvider maxSnack={3}>
                <AppContent />
            </SnackbarProvider>
        </AuthProvider>
    );
}

export default App;
